<!-- eslint-disable vue/no-unused-components -->
<template>
  <div class="email-cont">
    <div class="top-img">
      <speedCom v-if="currStatus === 1" :list="list" nowType="1"></speedCom>
      <speedCom
        v-else-if="currStatus === 2"
        :list="list"
        nowType="2"
      ></speedCom>
      <speedCom v-else :list="list" nowType="1"></speedCom>
   
    </div>
    <div class="email-info" v-if="currStatus === 1">
      <el-form
        :model="emailForm"
        :rules="emailRules"
        ref="emailForm"
        class="code-from"
        @submit.native.prevent
      >
        <el-form-item prop="email">
          <el-input
            v-model="emailForm.email"
            placeholder="请输入账号绑定邮箱"
            @focus="clearVerify('emailForm', 'email')"
            @change="emailChange"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="btn-box">
        <div class="btn" @click="findpwd" @keyup.enter.prevent="(e)=>keyDown(e)">{{ btnValue }}</div>
        <p>
          <span @click="$emit('toLogin')">返回登录</span>
        </p>
      </div>
    </div>
    <div class="email-verify" v-else-if="currStatus === 2">
      <div class="btn-box">
        <p>密码重置邮箱已经发送至邮箱：</p>
        <p>{{ emailForm.email }}</p>
        <p>请登录邮箱激活链接重置密码</p>
      </div>
      <p class="goBack">
        <span @click="$emit('toLogin')">返回登录</span>
      </p>
    </div>
  </div>
</template>

<script>
import { sendemail } from "@/../api";
import { mapState, mapMutations } from "vuex";
import { zhugeTrack, comPop, jumpAfterLogin, gotoEmail } from "@/utils/utils";
import speedCom from "@/components/common/speed";
export default {
  name: "",
  props: ["referUrl"],
  components: {
    speedCom,
  },
  data() {
    return {
      list: ["输入邮箱", "邮箱验证", "重置密码"],
      currStatus: 1,
      userEmail: "",
      btnValue: "下一步",
      pwdError: false,
      emailForm: {
        email: "",
      },
      emailRules: {
        email: [
          { validator: this.pwdvalidator},
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            pattern: /^\w+([-+.]\w+)*@\w+([-.]\w{2,})*\.\w{2,}([-.]\w{2,})*$/,
            message: "邮箱格式不正确！",
            trigger: "blur",
          },
        ],
      },
     btnLoading:false,
    };
  },
    mounted(){
    window.addEventListener('keydown',this.keyDown)
  },
  destroyed(){
    window.removeEventListener('keydown',this.keyDown,false)
  },
  methods: {
 
    ...mapMutations(["toastshow", "toastHidden", "manyLoginToastshow"]),
    keyDown(e){
      if((e.keyCode==13||e.keyCode==100) ){
        if(this.currStatus === 1){
            this.findpwd()
        }else{
          // this.$emit('toLogin')

        }
        
      }
    },
    pwdvalidator(rule, value, callback) {
      if (this.pwdError) {
        return callback(new Error(this.pawErrMsg));
      } else {
        callback();
      }
    },
    show(message = "默认", duration = 3000) {
      this.toastshow(message);
   
         const toastTimer= setTimeout(() => {
       this.toastHidden();
        clearTimeout(toastTimer)
      }, duration);
    },
    
    findpwd() {
      if (this.btnValue != "下一步") return;
      this.$refs["emailForm"].validate((valid) => {
        if (valid) {
          if(this.btnLoading) return
          this.btnLoading=true
          let obj = {
            email: this.emailForm.email,
            clientType: "PC",
          };
          // 邮件发送中...
          this.btnValue = "邮件发送中...";
          sendemail(obj).then((res) => {
            let data = res.data;
             this.btnLoading=false
            if (data.status == 200) {
              this.currStatus = 2;
              this.btnValue = "下一步";
            } else if (data.status == 401) {
              this.pwdError = true;
              this.pawErrMsg = "该邮箱尚未绑定账号";
              this.$refs["emailForm"].validateField("email");
              this.btnValue = "下一步";
            } else {
              this.show("发送失败");
              this.btnValue = "下一步";
            }
            
          });
        }
      });
    },
      emailChange() {
      this.pwdError = false;
      this.clearVerify('emailForm', 'email')
    },
    // 清除单个表单项验证
    clearVerify(refName, item) {
      this.$refs[refName].clearValidate(item);
    },
  },
};
</script>

<style lang="scss" scoped>
.email-cont {
  margin-top: 42px;
  position: relative;
  padding-left: 48px;
  ::v-deep .el-input__inner {
    width: 368px;
    height: 40px;
    line-height: 40px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 4px;
    border: 1px solid #e5e6eb;
    &:focus {
      border: 1px solid #4080ff;
    }
  }
  ::v-deep .is-error {
    .el-input__inner {
      border: 1px solid red;
    }
    .el-form-item__error {
      color: red;
      padding-top: 0px;
      height: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #f53f3f;
      line-height: 20px;
    }
  }
  .speed {
    display: flex;
    .one {
    }
    .heng {
      width: 44px;
      height: 1px;
      border: 1px solid #e5e6eb;
    }
  }
  // 输入邮箱
  .email-info {
    margin-top: 32px;
    .btn-box {
      margin-top: 32px;
      .btn {
        width: 368px;
        height: 44px;
        background: #165dff;
        border-radius: 4px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 44px;
        text-align: center;
        &:hover {
          background-color: #4080ff;
        }
      }
      p {
        font-family: PingFangSC-Regular, PingFang SC;
        color: #4e5969;
        font-size: 14px;
        height: 22px;
        line-height: 22px;
        margin: 108px 0 0 156px;
        span {
          cursor: pointer;
          &:hover {
            color: #165dff;
          }
        }
        .check-type {
          float: right;
          color: #466de2;
        }
      }
    }
  }
  // 邮箱验证
  .email-verify {
    margin-top: 32px;
    .btn-box {
      width: 368px;
      height: 172px;
      background: rgba(255, 255, 255, 0.9);
      border-radius: 4px;
      border: 1px solid #e5e6eb;
    }
    p {
      text-align: center;
      height: 22px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1d2129;
      line-height: 22px;
      text-align: center;
      &:nth-child(1) {
        margin-top: 40px;
      }
      &:nth-child(3) {
        margin-top: 26px;
      }
      .check-type {
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .goBack {
      color: #4e5969;
      font-size: 14px;
      height: 22px;
      line-height: 22px;
      margin: 52px 0 0 156px;
      text-align: left;
      span {
        cursor: pointer;
        &:hover {
          color: #165dff;
        }
      }
      .check-type {
        float: right;
        color: #466de2;
      }
    }
  }
}
</style>
